import * as Apps from './reducer/apps'
import * as Auth from './reducer/auth'
import * as Nav from './reducer/navigations'
import * as Api from './reducer/apiHandling'

export const { doLogout, initComplete, initMe, login, logout, setApps, successLogin } = Auth;
export const { loadAirlines, loadAirports, loadConsignee, loadHsCode, loadVersion, loadVersionLast, setHsCode, setVersionLast, setVersion, setAirline, setAirport, setConsignee, setLoading, unsetLoading, loadCofigs, setConfig } = Apps;
export const { setOpenKeys, setSelectedMenu, setSelectedMenuKeys } = Nav;
export const { GetAPI, PostAPI } = Api;